import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * Ya no incluye el "Steex Builder" (selector de layout/tema/colores) — era
 * una herramienta de demo del theme, sin uso real en FuturaPro. Solo queda el
 * botón "volver arriba" y el preloader (que se oculta solo desde
 * layout.component.ts, no depende de nada de acá).
 */
@Component({
  selector: 'app-rightsidebar',
  templateUrl: './rightsidebar.component.html',
  styleUrls: ['./rightsidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RightsidebarComponent {

  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
